import _ from "lodash"
import * as React from "react"
import { useState } from "react"
import { BtnEvent } from "../../api/EventTypes"
import { useAppSelector } from "../../app/hooks"
import { PageId } from "../../common/pageId"
import { CommonText, FormText } from "../../common/text"
import { IFieldValues, IPagesHistory } from "../../containers/selectionSlice"
import { IFieldConfig } from "../../pages/Config"
import { IFlightSelectorValues } from "../FlightSelector"
import HistoryValueRow from "../HistoryValueRow"

import CustomModal from "../modal"

export interface HistoryModalProps {
  visible: boolean
  hasActiveSearch: boolean
  excludeFields: IFieldConfig
  onClose: () => void
  onSelect: (chosenHistory: IFieldValues) => void
}

export const HistoryModal: React.FunctionComponent<HistoryModalProps> = ({
  visible,
  hasActiveSearch,
  excludeFields,
  onClose,
  onSelect
}) => {
  const [chosenHistory, setChosenHistory] = useState<IFieldValues>(null)
  const historySelection: IPagesHistory = useAppSelector(
    (state) => state["selectionReducer"].pagesHistory
  )
  const pageHistory = historySelection[PageId.All]

  let historyClone = pageHistory
    ? _.cloneDeep(pageHistory.history).reverse()
    : []

  if (hasActiveSearch) {
    const i = historyClone.findIndex((h) => !h.addToQuery)

    historyClone = historyClone.filter((h, idx) => idx > i)
  }

  const historyRows = historyClone.map((h: IFlightSelectorValues, idx) => {
    const isChosen = _.isEqual(chosenHistory, h)
    return (
      <HistoryValueRow
        key={idx}
        historyValues={h}
        onClick={() => {
          setChosenHistory(isChosen ? null : h)
        }}
        excludeFields={excludeFields}
        chosen={isChosen}
      />
    )
  })

  let closeModal = () => {
    onClose()
    setChosenHistory(null)
  }

  return (
    <CustomModal
      isOpen={visible}
      onClose={(e: BtnEvent) => {
        if (e.currentTarget === e.target) {
          closeModal()
        }
      }}
      title={FormText.searchHistory}
      ctaText={CommonText.select}
      onCallback={() => {
        if (chosenHistory) {
          onSelect(chosenHistory)
        }
      }}
      size="lg"
      onToggle={closeModal}
    >
      <div className="ocs-modal-history-body">
        <div className="ocs-search-history-rows">{historyRows}</div>
      </div>
    </CustomModal>
  )
}
